import React from 'react';
import { message } from '@/components/Message';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import styles from './style.less';
import PosButton from '../PosButton';
import { modalPrompt } from '@/utils/uiHelper';
import { playSound } from '@/utils/sound';

type Props = {
  step?: number;
  min?: number;
  max?: number;
  value?: number;
  onChange?: (value: number) => void;
  manualInput?: boolean;
};

const ClickInputNumber: React.FC<Props> = ({
  min = Number.MIN_SAFE_INTEGER,
  max = Number.MAX_SAFE_INTEGER,
  manualInput = false,
  step = 1,
  value,
  onChange = () => {},
}: Props) => {
  const onSelect = newValue => {
    newValue = Math.min(newValue, max);
    newValue = Math.max(newValue, min);
    onChange(newValue);
  };
  if (value === undefined) {
    value = 0;
  }
  return (
    <div className={styles.container}>
      <PosButton
        shape={'circle'}
        icon={<MinusOutlined />}
        onClick={() => {
          onSelect(value - step);
        }}
      />
      <PosButton
        shape={'round'}
        onClick={() => {
          if (manualInput) {
            modalPrompt({
              title: '请输入',
              onOk: v => {
                if (!isNaN(v) && v >= min && v <= max) {
                  onSelect(v);
                } else {
                  playSound('error');
                  message.error(`请输入${min}至${max}之间的整数`);
                  return false;
                }
              },
              useNumberKeyboard: true,
              numberKeyboardProps: {
                precision: 0,
                showAllClean: true,
              },
            });
          }
        }}>
        {value}
      </PosButton>
      <PosButton
        shape={'circle'}
        icon={<PlusOutlined />}
        onClick={() => {
          onSelect(value + step);
        }}
      />
    </div>
  );
};

export default ClickInputNumber;
